import React from "react";
import {Input} from 'antd';
import _ from "i18n";

const EnterTag = ({value, onChange}) => {
  return <div className={"flex items-center"}
              style={{"padding": "1.5rem", "height": "100%"}}>
    <div className={"user-card-container w-full"}>
      <div className={"m-3 text-center"}>{_('ENTER_TAG')}</div>
        <div className={"flex justify-center mb-3"}>
          <Input
            value={value}
            onChange={onChange}
            className={"feed-mango-input"}
            style={{"width": "450px"}}
          />
        </div>
      </div>
    </div>;
}
export default EnterTag;




// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/EnterTag.js